import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { getShowPdfUrl, resourcesInstallations } from "../../helpers/backend_helper";
import {
  DestroyAlertHelper,
  Alert,
  ToastHelper,
} from "../../helpers/alerts/alertHelper";
import { getPolicyUser, getStorageUser } from "../../helpers/api_helper";
import Generales from "./Show/Generales";
import Files from "./Tabs/Files";
import Tests from "./Tabs/Tests";
import PreviewPDF from "../../helpers/previewPDF";
import * as url from "../../helpers/url_helper"
import {
  Container,
  CardHeader,
  Col,
  Card,
  CardBody,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Table,
  Spinner,
} from "reactstrap";
import classnames from "classnames";
import {
  initialValues,
  parseFormValues,
  validationSchema,
} from "./Sections/yup.validation";
import { useFormik } from "formik";
import VehicleFiles from "./Sections/VehicleFiles";
import OperativeTests from "./Sections/OperativeTests";
import Conditions from "./Sections/Conditions";
import CardLoader from "../../components/Common/CardLoader";

const Show = () => {
  const user = getStorageUser();
  const policy = getPolicyUser();
  const { id } = useParams();
  const [isDownloadingPDF, setIsDownloadingPDF] = useState(false);
  const [pending, setPending] = useState(true);
  const [modal, setModal] = useState({ show: false });
  const [installation, setInstallation] = useState({
    conditions: [],
    tests: [],
  });
  const dispatch = useDispatch();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
  });

  useEffect(() => {
    setPending(true);
    resourcesInstallations("show", {}, id)
      .then((response) => {
        const { installation } = response;
        const files = _.keyBy(installation.files, "name");

        validation.setValues({
          ...validation.values,
          ...installation,
          files: {
            ...validation.values.files,
            ...files,
          },
        });

        setInstallation(response.installation);
      })
      .finally(() => {
        setPending(false);
      });
  }, []);
  const [currentActiveTab, setCurrentActiveTab] = useState("1");
  // Toggle active state for Tab
  const toggle = (tab) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  };

  const getReports = (type) => {
    let config = {
      params: {},
      headers: {
        Accept:
          type == 2
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "blob",
    };
    console.log('user', user);
    setIsDownloadingPDF(true);
    const url = getShowPdfUrl(id, user.id);
    setModal({ show: true, update: false, url: url });
    setIsDownloadingPDF(false);
    /*
    resourcesInstallations("show", config, id).then((response) => {
      if (type == 1) {
        console.log(response);
        const url = URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Reporte de Excesos.xlsx");
        document.body.appendChild(link);
        link.click();
      } else {
        let nombre = "instalacion_" + id;
        var reader = new FileReader();
        reader.readAsDataURL(response);
        reader.fileName = nombre;
        reader.onload = function () {
          var base64data = reader.result;
          
        };
        reader.onerror = function (error) {console.log(error)}
      }
    }).finally(() => {
      setIsDownloadingPDF(false);
    });
    */
  };

  document.title = "Instalación | Instalaciones";

  if (pending)
    return (
      <div className="page-content">
        <CardLoader title="Cargando datos de la instalación" />
      </div>
    );

  return (
    <React.Fragment>
      <div className="page-content custom-disabled show-installation">
        <Container fluid>
          <Row>
            <Col lg="12">
              <Card>
                <CardHeader>
                  <div style={{ textAlign: "right" }}>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => getReports(2)}
                      disabled={isDownloadingPDF}
                      title="Descargar PDF"
                    >
                      {isDownloadingPDF && (
                        <Spinner size="sm">
                          Loading...
                        </Spinner>
                      )}
                      <span>
                        {' '}
                      </span>
                      <i className="fa fa-file-pdf"></i> &nbsp;PDF
                    </button>
                  </div>
                  <p>Detalles de instalación</p>
                  <h2 style={{ textAlign: "center" }}>
                    Control de Recepción de Vehículo
                  </h2>
                  <p style={{ textAlign: "right" }}>
                    Fecha y hora: <b>{installation.fecha}</b>
                  </p>
                  <p style={{ textAlign: "right" }}>
                    Tipo de instalación: <b>{installation.tipo?.name}</b>
                  </p>
                </CardHeader>
                <CardBody>
                  <div>
                    <Generales item={installation} setItem={setInstallation} />
                  </div>
                  <div>
                    <Conditions
                      selected={installation?.vehicleConditions}
                      validation={validation}
                      isReadOnly
                    />
                    <OperativeTests
                      selected={installation?.operativeTests}
                      validation={validation}
                      isReadOnly
                    />
                    <VehicleFiles
                      title="Evidencias Fotograficas"
                      validation={validation}
                      isOnlyRead
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {modal.show && <PreviewPDF modalPdf={modal} setModalPdf={setModal} />}
      </div>
    </React.Fragment>
  );
};

export default Show;
